export const SUMMARY_CONFIG_VDP = {
  style: {
    display: '{value}',
    title: 'Style',
    className: 'text-transform-none',
  },
  mileage: {
    display: '{value}',
    title: 'Mileage',
  },
  exteriorColor: {
    title: 'Ext. Color',
  },
  interiorColor: {
    title: 'Int. Color',
  },
  mpg: {
    title: 'MPG',
  },
  mpge: {
    title: 'MPGe',
  },
  transmission: {
    display: '{value}',
    title: 'Transmission',
  },
  driveTrain: {
    display: '{value}',
    title: 'Drivetrain',
  },
  enginePower: {
    display: '{value} hp',
    title: 'Horsepower',
    className: 'text-transform-none',
  },
  engineType: {
    display: '{value}',
    title: 'Engine',
  },
  bedLengthMeasurement: {
    display: '{value}',
    title: 'Bed Length',
  },
  rearWheels: {
    display: '{value}',
    title: 'Dual rear wheels',
  },
  numberOfSeats: {
    display: '{value}',
    tooltip: 'Based on default model values and available option information. Contact dealer to confirm.',
    title: 'Seats',
  },
  towingCapacity: {
    display: 'Up to {value} lbs',
    tooltip:
      'Based on the highest towing capacity available for this style. Actual towing capacity varies by configuration and may require optional equipment. Contact dealer to confirm.',
    title: 'Max Towing Capacity',
    className: 'text-transform-none',
    colClassName: 'ms-0',
  },
  payloadCapacity: {
    display: '{value} lbs',
    tooltip:
      'Based on vehicle with no options selected. Vehicle options may impact payload capacity. Contact dealer to confirm.',
    title: 'Standard Payload Capacity',
    className: 'text-transform-none',
  },
  vin: {
    display: '{value}',
    title: 'VIN',
    className: 'text-transform-none',
  },
  stock: {
    display: '{value}',
    title: 'Stock #',
    className: 'text-transform-none',
  },
  electricityRange: {
    display: '{value} mi',
    title: 'Battery Range',
    className: 'text-transform-none',
  },
  batteryChargeTime: {
    display: '{value} hrs',
    title: 'Battery Charge Time',
    className: 'text-transform-none',
  },
  finalAssembly: {
    display: '{value}',
    title: 'Country of Final Assembly',
    className: 'text-transform-none',
    valueClass: 'text-capitalize',
  },
};
